import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast.service';
import { 
  LucideAngularModule, 
  CheckCircle, 
  AlertCircle, 
  AlertTriangle, 
  Info, 
  X 
} from 'lucide-angular';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, LucideAngularModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  toastService = inject(ToastService);
  
  readonly SuccessIcon = CheckCircle;
  readonly ErrorIcon = AlertCircle;
  readonly WarningIcon = AlertTriangle;
  readonly InfoIcon = Info;
  readonly CloseIcon = X;

  getIcon(type: string) {
    switch (type) {
      case 'success': return this.SuccessIcon;
      case 'error': return this.ErrorIcon;
      case 'warning': return this.WarningIcon;
      default: return this.InfoIcon;
    }
  }
}
